import { useEffect } from "react";
import { useCallback } from "react";
import {
  updateDynaMXFormIDContext,
  updateDynaMXFormAPIURLContext,
  updateDynaMXFormCountryInputIDContext,
  updateDynaMXFormDropdown1IDContext,
  updateDynaMXFormDropdown2IDContext,
  updateDynaMXFormDropdown3IDContext,
  updateDynaMXHomeTypesDDIdContext,
  updateDynaMXPriceRangesDDIdContext,
  updateDynaMXIsAgentCBIdContext,
  updateDynaMXIsTextMessageCBIdContext,
  updateDynaMXIsConsentCBIdContext,
  useUiValue,
} from "stores/uiContext";

const useDynamicsForm = () => {
  const [
    {
      dynaMXFormID,
      dynaMXFormAPIURL,
      dynaMXCountryInputID,
      dynaMXDropdown1ID,
      dynaMXDropdown2ID,
      dynaMXDropdown3ID,
      dynaMXPriceRangesDDId,
      dynaMXHomeTypesDDId,
      dynaMXIsAgentCheckBoxId,
      dynaMXIsTextMessageCheckBoxId,
      dynaMXIsConsentCheckBoxId,
    },
    dispatch,
  ] = useUiValue();
  const updateDynaMXFormID = useCallback(
    (id) => {
      dispatch(updateDynaMXFormIDContext(id));
    },
    [dynaMXFormID]
  );
  const updateDynaMXFormAPIURL = useCallback(
    (api) => {
      dispatch(updateDynaMXFormAPIURLContext(api));
    },
    [dynaMXFormAPIURL]
  );

  const updateDynaMXFormCountryInputID = useCallback(
    (id) => {
      dispatch(updateDynaMXFormCountryInputIDContext(id));
    },
    [dynaMXCountryInputID]
  );
  const updateDynaMXFormDropdown1ID = useCallback(
    (id) => {
      dispatch(updateDynaMXFormDropdown1IDContext(id));
    },
    [dynaMXDropdown1ID]
  );
  const updateDynaMXFormDropdown2ID = useCallback(
    (id) => {
      dispatch(updateDynaMXFormDropdown2IDContext(id));
    },
    [dynaMXDropdown2ID]
  );
  const updateDynaMXFormDropdown3ID = useCallback(
    (id) => {
      dispatch(updateDynaMXFormDropdown3IDContext(id));
    },
    [dynaMXDropdown3ID]
  );
  const updateDynaMXHomeTypesDDId = useCallback(
    (id) => {
      dispatch(updateDynaMXHomeTypesDDIdContext(id));
    },
    [dynaMXHomeTypesDDId]
  );
  const updateDynaMXPriceRangesDDId = useCallback(
    (id) => {
      dispatch(updateDynaMXPriceRangesDDIdContext(id));
    },
    [dynaMXPriceRangesDDId]
  );
  const updateDynaMXIsAgentCBId = useCallback(
    (id) => {
      dispatch(updateDynaMXIsAgentCBIdContext(id));
    },
    [dynaMXIsAgentCheckBoxId]
  );
  const updateDynaMXIsTextMessageCBId = useCallback(
    (id) => {
      dispatch(updateDynaMXIsTextMessageCBIdContext(id));
    },
    [dynaMXIsTextMessageCheckBoxId]
  );
  const updateDynaMXIsConsentCBId = useCallback(
    (id) => {
      dispatch(updateDynaMXIsConsentCBIdContext(id));
    },
    [dynaMXIsConsentCheckBoxId]
  );

  return {
    dynaMXFormID,
    dynaMXFormAPIURL,
    dynaMXCountryInputID,
    dynaMXDropdown1ID,
    dynaMXDropdown2ID,
    dynaMXDropdown3ID,
    dynaMXPriceRangesDDId,
    dynaMXHomeTypesDDId,
    dynaMXIsAgentCheckBoxId,
    dynaMXIsTextMessageCheckBoxId,
    dynaMXIsConsentCheckBoxId,
    updateDynaMXFormID,
    updateDynaMXFormAPIURL,
    updateDynaMXFormCountryInputID,
    updateDynaMXFormDropdown1ID,
    updateDynaMXFormDropdown2ID,
    updateDynaMXFormDropdown3ID,
    updateDynaMXHomeTypesDDId,
    updateDynaMXPriceRangesDDId,
    updateDynaMXIsAgentCBId,
    updateDynaMXIsTextMessageCBId,
    updateDynaMXIsConsentCBId,
  };
};
export default useDynamicsForm;
